import { getters } from '/@/modules/core/app/helpers/store';

export const HasCurrentEstateMixin = {
  computed: {
    currentEstate() {
      return getters.auth.getCurrentEstate();
    },
    estateName() {
      return this.currentEstate?.contact?.fullName;
    },
    isClearVault() {
      return this.currentEstate?.isClearVault;
    },
    isClearWill() {
      return this.currentEstate?.isClearWill;
    },
    isStandardPlan() {
      return this.isClearWill || this.currentEstate?.isStandardPlan;
    },
    isSelfServe() {
      return this.isClearWill || this.currentEstate?.isSelfServePlan;
    },
    isClearEstate() {
      return this.currentEstate?.isClearEstate;
    },
    isProbateLockedEstate() {
      return this.currentEstate?.isProbateLocked;
    },
    isDemo() {
      return this.currentEstate?.isDemo;
    },
    isInsideEstate() {
      return !!this.currentEstate;
    },
    paywall() {
      return this.currentEstate?.paywall;
    },
    primaryEstateProfessional() {
      return this.currentEstate?.estateAdminUsers.find(
        (user) => user.estateAccount.isPrimaryEstateProfessional
      );
    }
  }
};
